module.exports = __webpack_public_path__ + "static/condo_design-2-f4ce80672def81dfccc20a30be0dae44.jpg";